import { useEffect, useState } from "react";
import { useAppBlocksContext } from "../../../../../../context/AppBlocksContext";
import { getDefaultConfig } from "../../../../../../utils/Config/getDefaultConfig";

import EditButtonConfig from "../../../../../../components/EditComponents/EditButtonConfig";
import {
  columnOperatorData,
  operatorData
} from "../../../../../../components/BuilderComponents/PreFilters/operatorData";
import BuilderModal from "../../../../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../../../../components/BuilderComponents/TableTreeModal";
import ValueAccordingOperator from "../../../../../../components/BuilderComponents/PreFilters/ValueAccordingOperator";
import RecordsetListCardDesign from "../../../../DetailsViewRenderer/Desktop/RecordsetListCardDesign";
import Input from "../../../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../../../components/FormComponents/SingleSelectBox";
import Button from "../../../../../../components/FormComponents/Button";
import MaterialIcon from "../../../../../../components/BuilderComponents/MaterialIcon";
import { hasOwn } from "../../../../../../commonFunctions/arrayFunc";
import { generateObjectId } from "../../../../../../utils/objectIdUtils";

const EditCustomColumn = ({
  editColumn,
  showEditColumnBar,
  tableRef,
  table_id,
  // activity_id,
  afterEffectOfFilter,
  setNonSelectedFilter
  // setEditColumn
}) => {
  const [isModalOpen, setIsModalOpen] = useState(null);
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();

  const columnToEdit = recordsviewLayout?.columns[editColumn.payload.index];

  const addElementToCustom = (type) => {
    const copyObj = { ...recordsviewLayout };
    let obj = {};

    if (type === "button") {
      obj = getDefaultConfig("button");
    }
    if (type === "dropdown") {
      obj = getDefaultConfig("dropdown");
    }

    obj.id = generateObjectId();
    copyObj.columns[editColumn.payload.index].config.push(obj);
    showEditColumnBar(editColumn.payload.index, columnToEdit.id, columnToEdit.config.length - 1, obj.id);
    setRecordsviewLayout(copyObj);
  };

  const makeButtonConfig = () => {
    const obj = recordsviewLayout.columns[editColumn.payload.index].config[editColumn.payload.subIndex];
    const newObj = {
      id: obj.id,
      type: obj.type,
      config: obj,
      elements: [applicationBlockData]
    };
    return newObj;
  };

  const handleSaveColumnConfig = (where, config) => {
    const copyObj = { ...recordsviewLayout };
    copyObj.columns[editColumn.payload.index].config[editColumn.payload.subIndex] = config;
    setRecordsviewLayout(copyObj);
  };

  const handleAggrigateColumn = (data) => {
    const copyObj = JSON.parse(JSON.stringify(recordsviewLayout));
    copyObj.columns[editColumn.payload.index].aggregate_column = data.id;
    setRecordsviewLayout(copyObj);
    setIsModalOpen(null);
  };
  const handleInputChange = (name, value) => {
    const copyObj = JSON.parse(JSON.stringify(recordsviewLayout));
    copyObj.columns[editColumn.payload.index][name] = value;
    setRecordsviewLayout(copyObj);
    afterEffectOfFilter(copyObj);
  };

  const updateCustomCol = (col) => {
    const copyObj = JSON.parse(JSON.stringify(recordsviewLayout));
    copyObj.columns[editColumn.payload.index] = col;
    setRecordsviewLayout(copyObj);
  };

  const handleSaveRecordsetLayout = (data) => {
    const fields = data.filter((obj) => obj.element_config.type === "field").map((obj) => obj.element_config);

    setNonSelectedFilter((prevState) => [...prevState, ...fields]);

    const copyRecordviewlayout = JSON.parse(JSON.stringify(recordsviewLayout));
    const colIndex = copyRecordviewlayout.columns.findIndex((col) => col.id === columnToEdit.id);
    if (colIndex !== -1) {
      if (!copyRecordviewlayout.columns[colIndex].layout_config) {
        copyRecordviewlayout.columns[colIndex].layout_config = {};
      }
      copyRecordviewlayout.columns[colIndex].layout_config.layouts = data;
      setRecordsviewLayout(copyRecordviewlayout);
    }
    setIsModalOpen(null);
  };

  const getLayoutDataForColumn = (id) => {
    try {
      if (!id) {
        throw new Error("Column ID is required");
      }

      const column = recordsviewLayout?.columns?.find((c) => c.id === id);

      if (!column) {
        console.warn(`Column with ID ${id} not found`);
        return [];
      }

      if (!column.layout_config || !column.layout_config.layouts) {
        console.warn(`Layout config for column with ID ${id} is missing or incomplete`);
        return [];
      }

      return column.layout_config.layouts;
    } catch (error) {
      console.error("Error getting layout data for column:", error);
      return [];
    }
  };

  const handleUpdateWidth = (name, value) => {
    const copyObj = JSON.parse(JSON.stringify(recordsviewLayout));
    copyObj.columns[editColumn.payload.index][name] = value;
    setRecordsviewLayout(copyObj);
  };

  const widthOptions = [
    { id: "width", name: "width" },
    { id: "max_width", name: "max width" },
    { id: "min_width", name: "min width" }
  ];

  const customTypeOptions = [
    { id: "button", name: "Button" },
    { id: "aggregate_column", name: "Aggregate Column" },
    { id: "rich_column", name: "Rich column" }
  ];

  const aggregateFunctionOptions = [
    { id: "", name: "none" },
    { id: "sum", name: "sum" },
    { id: "count", name: "count" },
    { id: "count_if", name: "count if" }
  ];

  return (
    <div className="config_child_container">
      {editColumn.payload.subIndex === 0 || editColumn.payload.subIndex ? (
        <div className="edit_right_panel_inside">
          <EditButtonConfig
            editElementRightsidebar={makeButtonConfig()}
            onSave={(config) => handleSaveColumnConfig("custom", config)}
            places="records_view_row"
            smId={recordsviewLayout.table_id}
            device={applicationBlockData.device}
            type={applicationBlockData.table_type}
          />
        </div>
      ) : (
        <>
          <div className="custom_type_name_container builder_form">
            <Input
              label="Column Label"
              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
              name="display"
              value={columnToEdit?.display}
            />
            <SingleSelectBox
              selectedData={columnToEdit?.width_type || ""}
              options={widthOptions}
              onChange={(obj) => handleUpdateWidth("width_type", obj.id)}
              placeholder="select"
              label="Select width type"
            />
            {columnToEdit?.width_type && (
              <>
                <Input
                  label="Width(in pixels)"
                  type="number"
                  name="width_value"
                  onChange={(e) => handleUpdateWidth(e.target.name, e.target.value)}
                  value={columnToEdit?.width_value || ""}
                />
              </>
            )}
            <SingleSelectBox
              selectedData={columnToEdit?.custom_type || "button"}
              options={customTypeOptions}
              onChange={(obj) => handleInputChange("custom_type", obj.id)}
              placeholder="select type"
              label="Custom Type"
            />
            {columnToEdit?.custom_type === "aggregate_column" && (
              <>
                <div className="builder_form">
                  <label className="builder_label">Aggregate Column</label>
                  <div className="builder_displayBox" onClick={() => setIsModalOpen("aggregate_column")}>
                    <div>
                      {columnToEdit?.aggregate_column
                        ? tableRef.current[columnToEdit?.aggregate_column]?.prefix +
                          "." +
                          tableRef.current[columnToEdit?.aggregate_column]?.display
                        : "No field assign"}
                    </div>
                  </div>
                  <SingleSelectBox
                    selectedData={columnToEdit.aggregate_function}
                    options={aggregateFunctionOptions}
                    onChange={(obj) => handleInputChange("aggregate_function", obj.id)}
                    placeholder="none"
                    label="Aggregate Function"
                  />
                  {(columnToEdit.aggregate_function === "sum_if" || columnToEdit.aggregate_function === "count_if") && (
                    <CustomColumnGroupData
                      field={recordsviewLayout.columns[editColumn.payload.index]}
                      handleChange={updateCustomCol}
                      // index={editColumn.payload.index}
                      allTableColumns={tableRef.current}
                      tableId={table_id}
                    />
                  )}
                </div>
              </>
            )}

            {columnToEdit?.custom_type === "rich_column" && (
              <>
                <Button variant="secondary" onClick={() => setIsModalOpen("rich_column")}>
                  Edit Column
                </Button>
              </>
            )}
            {columnToEdit?.custom_type === "button" && (
              <div className="custom_type_selector_container">
                <div className="config_child_header_container">
                  <p className="config_child_header_title">Add Button</p>
                </div>
                <div className="custom_type_menu_container">
                  <Button variant="plain" onClick={() => addElementToCustom("button")}>
                    Button
                  </Button>
                  <Button variant="plain" onClick={() => addElementToCustom("dropdown")}>
                    <p>Dropdown</p>
                    <MaterialIcon name="expand_more" />
                  </Button>
                </div>
              </div>
            )}
          </div>
        </>
      )}
      <BuilderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(null)}
        modalName={isModalOpen === "aggregate_column" ? "Add Aggregate Column" : "Create Rich Cell"}
      >
        {isModalOpen === "aggregate_column" && (
          <TableTreeModal
            callbackFunction={handleAggrigateColumn}
            tableId={recordsviewLayout.table_id}
            selectedFile={
              columnToEdit?.aggregate_column && tableRef?.current?.[columnToEdit.aggregate_column]?.id
                ? tableRef.current[columnToEdit.aggregate_column].id
                : ""
            }
          />
        )}
        {isModalOpen === "rich_column" && (
          <RecordsetListCardDesign
            tableRef={tableRef}
            layoutData={getLayoutDataForColumn(columnToEdit.id)}
            tableId={recordsviewLayout.table_id}
            tableType={recordsviewLayout.table_type}
            handleSaveRecordsetLayout={handleSaveRecordsetLayout}
            device={applicationBlockData.device}
          />
        )}
      </BuilderModal>
    </div>
  );
};

const CustomColumnGroupData = ({ field, handleChange, allTableColumns, tableId }) => {
  const [isGroupOpen, setIsGroupOpen] = useState(false);
  const [operatorListForType, setOperatorListForType] = useState([]);

  const handleGroupColumn = (data) => {
    const newTile = JSON.parse(JSON.stringify(field));
    if (!hasOwn(newTile, "aggregate_config")) {
      newTile.aggregate_config = {};
    }
    newTile.aggregate_config.group_by_column = data.id;
    handleChange(newTile);
    setIsGroupOpen(null);
  };
  const getOperatorList = () => {
    const newfield = allTableColumns[field?.aggregate_config?.group_by_column];
    if (newfield) {
      const operatorArray = [...operatorData, ...columnOperatorData].filter((op) =>
        op.fields.includes(newfield.field_type || newfield.type)
      );
      setOperatorListForType(operatorArray);
    }
  };

  const handleChangeValue = (type, value) => {
    const newTile = JSON.parse(JSON.stringify(field));
    newTile.aggregate_config[type] = type === "number_value" ? parseInt(value) : value;
    if (type === "operator") {
      const newObj = removeObjectKeys(newTile.aggregate_config);
      newTile.aggregate_config = newObj;
    }
    handleChange(newTile);
  };

  const removeObjectKeys = (obj) => {
    const newObj = JSON.parse(JSON.stringify(obj));
    const keysToDelete = [
      "text_value",
      "number_value",
      "number_range",
      "human_date",
      "custom_date_range",
      "text_array"
    ];
    keysToDelete.forEach((key) => {
      if (hasOwn(newObj, key)) {
        delete newObj[key];
      }
    });

    return newObj;
  };

  useEffect(() => {
    getOperatorList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field, allTableColumns]);
  return (
    <>
      <label className="builder_label">Group By Column</label>
      <div className="builder_displayBox" onClick={() => setIsGroupOpen(true)}>
        <div>
          {field?.aggregate_config?.group_by_column
            ? (allTableColumns[field.aggregate_config.group_by_column]?.prefix || "") +
              "." +
              allTableColumns[field.aggregate_config.group_by_column]?.display
            : "No field assign"}
        </div>
      </div>

      {field?.aggregate_config?.group_by_column && (
        <>
          <SingleSelectBox
            selectedData={field?.aggregate_config?.operator}
            options={operatorListForType}
            valueKey="operator"
            labelKey={["operator_name"]}
            onChange={(obj) => handleChangeValue("operator", obj.operator)}
            placeholder="Select operator"
            label="Operator"
          />

          <div>
            {field.aggregate_config.operator && (
              <ValueAccordingOperator
                value={operatorListForType.find((op) => op.operator === field.aggregate_config.operator)?.value}
                // index={index}
                updatePrefilter={handleChangeValue}
                field={{ ...field?.aggregate_config, id: field?.aggregate_config?.group_by_column }}
                tableId={tableId}
              />
            )}
          </div>
        </>
      )}

      <BuilderModal isOpen={isGroupOpen} onClose={() => setIsGroupOpen(null)} modalName={"Add Group By Column"}>
        <TableTreeModal
          callbackFunction={handleGroupColumn}
          tableId={tableId}
          selectedFile={
            field?.aggregate_config?.group_by_column && allTableColumns?.[field.aggregate_config.group_by_column]?.id
              ? allTableColumns[field.aggregate_config.group_by_column].id
              : ""
          }
        />
      </BuilderModal>
    </>
  );
};

export default EditCustomColumn;
export { CustomColumnGroupData };
